import {useQuery as useBaseQuery} from "@apollo/client";
import {DocumentNode, OperationVariables, TypedDocumentNode} from "@apollo/client/core";
import {QueryHookOptions, QueryResult} from "@apollo/client/react/types/types";


export function useQuery<TData = any, TVariables = OperationVariables>(query: DocumentNode | TypedDocumentNode<TData, TVariables>, options?: QueryHookOptions<TData, TVariables>): QueryResult<TData, TVariables> {
    const result = useBaseQuery(query, options);

    // https://github.com/apollographql/apollo-client/issues/8669#issuecomment-978012147
    if (options?.fetchPolicy == "cache-and-network" && result.loading) {
        const inCache = result.client.readQuery({
            query: query,
            variables: options.variables
        });
        if (inCache) {
            result.loading = false;
        }
    }
    return result;
}